import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createProductImageUrl } from '../../utils/productImageUrl';
import { formatPurchaseDate } from '../../utils/formatPurchaseDate';
import { formatPrice } from '../../utils/formatPrice';
import { countTotalKey, tEc } from './ecText';

function qtySum(lines) {
  return (lines || []).reduce((sum, line) => sum + (Number(line.product_qty) || 0), 0);
}

function storeNameOf(order, t) {
  return order.shop_name || order.purchase_place || t('ordersLayout.storeAddressPending');
}

function currencyOf(order) {
  const lines = order.product_list || [];
  return order.product_price_currency || (lines[0] && lines[0].product_price_currency) || '';
}

function hideBrokenImage(event) {
  event.currentTarget.style.display = 'none';
}

function scrollEcToTop() {
  const scroller = document.querySelector('.simplebar-content-wrapper');
  if (scroller) scroller.scrollTop = 0;
  window.scrollTo(0, 0);
}

export default function OrderListEc({ orders, onViewOrder }) {
  const { t, i18n } = useTranslation();
  const list = orders || [];

  useEffect(() => {
    scrollEcToTop();
  }, []);

  return (
    <div className="orders-ec">
      <header className="orders-ec__bar">
        <span className="orders-ec__bar-end" aria-hidden="true" />
        <h1 className="orders-ec__title">{t('ordersLayout.ecListTitle')}</h1>
        <span className="orders-ec__bar-end" aria-hidden="true" />
      </header>
      <main className="orders-ec__main">
        {list.length === 0 ? (
          <p className="orders-ec__empty">{t('ordersLayout.emptyOrders')}</p>
        ) : (
          <div className="orders-ec__list">
            {list.map((order, index) => {
              const lines = order.product_list || [];
              const first = lines[0];
              const img = first && (first.picture_url || createProductImageUrl(first));
              const count = qtySum(lines);
              const amount = formatPrice(order.order_grand_total, currencyOf(order), i18n.language);
              const countLabel = tEc(t, countTotalKey(count), { count, amount });
              return (
                <React.Fragment key={order.order_id || index}>
                  {index > 0 ? <div className="orders-ec__rule" /> : null}
                  <section className="orders-ec-card">
                    <div className="orders-ec-card__meta">
                      <p className="orders-ec-card__status">{t('ordersLayout.ecStatusInStore')}</p>
                      <p className="orders-ec-card__number">
                        {tEc(t, 'ordersLayout.ecOrderNumber', { order_number: order.order_id })}
                      </p>
                      <p className="orders-ec-card__date">
                        {tEc(t, 'ordersLayout.ecDateStore', {
                          date: formatPurchaseDate(order.purchase_date, i18n.language),
                          store_name: storeNameOf(order, t),
                        })}
                      </p>
                    </div>
                    <div className="orders-ec-card__thumb">
                      {img ? <img src={img} alt="" onError={hideBrokenImage} /> : null}
                    </div>
                    <div className="orders-ec-card__foot">
                      <span className="orders-ec-card__count">{countLabel}</span>
                      <button
                        type="button"
                        className="orders-ec-card__view"
                        aria-label={tEc(t, 'ordersLayout.ecViewOrderA11y', { order_number: order.order_id })}
                        onClick={() => onViewOrder(order)}
                      >
                        {t('ordersLayout.ecViewOrder')}
                      </button>
                    </div>
                  </section>
                </React.Fragment>
              );
            })}
          </div>
        )}
      </main>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/js/components/ordersLayout/OrderListEc.jsx